import React, { useState, useEffect } from 'react';
import Helmet from 'react-helmet';
import { Router, Link, Location } from '@reach/router';
import Layout from '../components/Layout/Layout';
import { siteTitle } from '../../data/SiteConfig';
import { isLoggedIn, getUserNumber } from '../common/utils/cookie-utils';
import {
  QueryParamProvider,
  useQueryParams,
  NumberParam,
  StringParam,
} from 'use-query-params';
import { navigate } from 'gatsby';
import ConsumerSignUp from '../containers/ConsumerSignUp/Steps/index';

export default function IndexPage() {
  const [invitevalues, setInvite] = useQueryParams({
    request: StringParam,
  });
  const [isLoggedin, setIsLoggedIn] = useState(isLoggedIn());
  const [userNumber, setUserNumber] = useState(getUserNumber());
  useEffect(() => {
    let invPhNo = JSON.parse(localStorage.getItem('action'))?.phone;
    if (isLoggedin) {
      if (invitevalues?.request) {
        if (invPhNo === userNumber) {
          navigate('/user/home');
        }
      } else {
        navigate('/user/home');
      }
    }
  }, []);

  return (
    <Layout>
      <div className="homepage">
        <Helmet title={`Consumer Login | ${siteTitle}`}>
          <link
            rel="icon"
            href="https://fincity-public.s3.ap-south-1.amazonaws.com/website/com/images/fincity-logo.png"
            type="image/icon type"
          />
          <link
            rel="stylesheet"
            href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"
          />
        </Helmet>
        <QueryParamProvider ReactRouterRoute={Location}>
          <ConsumerSignUp />
        </QueryParamProvider>
      </div>
    </Layout>
  );
}
